const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  error: isDev ? (...args) => console.error(...args) : () => {},
  warn: isDev ? (...args) => console.warn(...args) : () => {},
  info: isDev ? (...args) => console.info(...args) : () => {},
  log: isDev ? (...args) => console.log(...args) : () => {},
};
